type SelectableBoxProps = {
  id: string;
  label: string;
  description?: string;
  selected: boolean;
  onSelect: (id: string) => void;
};

const SelectableBox = ({ id, label, description, selected, onSelect }: SelectableBoxProps) => {
  return (
    <div
      className={`border rounded p-4 cursor-pointer transition-all ${
        selected ? "border-primary-600 bg-primary-50" : "border-gray-300 hover:border-primary-600"
      }`}
      onClick={() => onSelect(id)}
    >
      <div className="flex items-center gap-3">
        <div
          className={`w-5 h-5 flex-shrink-0 flex items-center justify-center rounded-full border-2 transition ${
            selected ? "border-primary-600" : "border-gray-400"
          }`}
        >
          {selected && <div className="w-3 h-3 bg-primary-600 rounded-full"></div>}
        </div>
        <span>{label}</span>
      </div>
      <div className="mt-2 text-sm text-gray-600 whitespace-pre-line">
        {description}
      </div>
    </div>
  );
};

export default SelectableBox;
